import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplay = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		clipPath: "url(#replay-clip)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M8 2a6 6 0 1 1 0 12v2A8 8 0 0 0 8 0zM3.964 3.56a6 6 0 0 1 2.085-1.236L5.399.433A8 8 0 0 0 2.618 2.08zM2.06 7.142a6 6 0 0 1 .687-2.044L.997 4.13a8 8 0 0 0-.916 2.728zm.69 3.765a6 6 0 0 1-.69-2.049l-1.98.284c.141.98.46 1.903.921 2.736zm3.299 2.769a6 6 0 0 1-2.085-1.237l-1.346 1.48a8 8 0 0 0 2.78 1.648z" }), /* @__PURE__ */ _jsx("path", { d: "m6 11 5-3-5-3z" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "replay-clip",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgReplay;
